export default [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
